<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              v-icon(color="basic800" :size="24") mdi-close
          v-col.ml-3
            .h6.basic800--text(v-if="option") {{ $t('update_option') }}
            .h6.basic800--text(v-else) {{ $t('add_option') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4

            .description.mt-4
              .label.basic600--text.text-uppercase.mb-1 {{ $t('description.label') }}
              v-text-field(v-model='optionData.name' :placeholder="$t('description.placeholder')" :hint="$t('description.hint')" outlined dense persistent-hint  :rules="rules.not_empty")
            v-row
              v-col
                .start-time
                  y-dialog(v-model='start.show' width='290px')
                    template(v-slot:activator='{ on }')
                      .label.basic600--text.text-uppercase.mb-1 {{ $t('start.label') }}
                      v-text-field(:value="start.time" :placeholder="$t('start.placeholder')" outlined dense :rules="rules.not_empty" readonly v-on='on')
                    v-time-picker.elevation-2(v-model='optionData.start_time' @change="saveStartTime()" color="textColorAccent")
              v-col
                .end-time
                  y-dialog(v-model='end.show' width='290px')
                    template(v-slot:activator='{ on }')
                      .label.basic600--text.text-uppercase.mb-1 {{ $t('end.label') }}
                      v-text-field(:value="end.time" :placeholder="$t('end.placeholder')" outlined dense :rules="rules.not_empty" readonly v-on='on')
                    v-time-picker.elevation-2(v-model='optionData.end_time' @change="saveEndTime()" color="textColorAccent")
            
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text Cancel
        v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clickSave" :loading="isLoading")
          .button-AA-small.basic100--text(v-if="option") {{ $t('update') }}
          .button-AA-small.basic100--text(v-else) {{ $t('add') }}

</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UpdateTenantBusinessHours',
  props: ['open', 'settings', 'option'],
  data: (v) => ({
    optionData: v.option || {
      id: null,
      name: null,
      start_time: null,
      end_time: null
    },
    start: {
      time: null,
      show: false
    },
    end: {
      time: null,
      show: false
    },
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.optionData.id) {
      this.start.time = this.formatTime(this.optionData.start_time)
      this.end.time = this.formatTime(this.optionData.end_time)
    }
  },
  methods: {
    saveStartTime () {
      this.start.time = this.formatTime(this.optionData.start_time)
      this.start.show = false
    },
    saveEndTime () {
      this.end.time = this.formatTime(this.optionData.end_time)
      this.end.show = false
    },
    formatTime (time24) {
      let ts = time24
      const H = + ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'AM' : 'PM'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.optionData.id) {
        this.$axios.put(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/business_hours/${this.optionData.id}/`, this.optionData)
        .then(resp => {
          this.$emit('edited', resp.data)
          this.showModal = false
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.$axios.post(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/business_hours`, this.optionData)
        .then(resp => {
          this.$emit('added', resp.data)
          this.showModal = false
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "add_option": "Add New Option",
    "update_option": "Update Option",
    "description": {
      "label": "Description",
      "placeholder": "Write option description here",
      "hint": "Example: Monday, Monday to Friday, Lunch break"
    },
    "start": {
      "label": "Start Hour",
      "placeholder": "Select start hour"
    },
    "end": {
      "label": "End Hour",
      "placeholder": "Select end hour"
    },
    "price": {
      "label": "Charge",
      "placeholder": "0"
    },
    "cancel": "Cancel",
    "update": "Update",
    "add": "Add"
  }
}
</i18n>
